export default "__VITE_ASSET__BnYYAYOn__"